import { useContext } from 'react'

import { UserTypeContext } from './UserTypeContext'

export const useUserTypeContext = () => useContext(UserTypeContext)
